import { Checks } from './check.types';

/**
 * Complete audit data for a page
 */
export interface AuditData {
  link: string;
  mobile: DeviceData | null;
  desktop: DeviceData | null;
}

/**
 * Analysis data for a specific device
 */
export interface DeviceData {
  visualAnalysis: Analysis;
  copyAnalysis: Analysis;
  performanceAnalysis: Analysis;
  seoAnalysis: Analysis;
  accessibilityAnalysis: Analysis;
}

/**
 * Analysis for a specific category
 */
export interface Analysis {
  bucket: string;
  checks: Checks;
  // Dynamic score properties
  [key: string]: string | number | Checks;
}

/**
 * Map data for curated content
 */
export interface MapData {
  [bucket: string]: {
    [checkKey: string]: CuratedCheckData;
  };
}

/**
 * Curated references and images for a check
 */
export interface CuratedCheckData {
  references?: Reference[];
  images?: ImageReference[];
}

export interface Reference {
  url: string;
  label: string;
}

export interface ImageReference {
  src: string;
  alt?: string;
}

/**
 * Track which pages exist for an audit
 */
export interface PageExistence {
  product: boolean;
  collection: boolean;
  home: boolean;
  cart: boolean;
}

/**
 * Primary category types for grouping insights
 */
export type PrimaryCategory = 'cro-ux' | 'technical';

/**
 * Mapping of analysis buckets to primary categories
 */
export const PRIMARY_CATEGORY_MAP: Record<string, PrimaryCategory> = {
  visual: 'cro-ux',
  copy: 'cro-ux',
  accessibility: 'cro-ux',
  performance: 'technical',
  seo: 'technical'
};

/**
 * Array of primary categories
 */
export const PRIMARY_CATEGORIES = ['cro-ux', 'technical'] as const;
